export default [
  {
    header: 'Вопросы',
    resource: 'questions',
    action: 'view',
  },
  {
    title: 'Список вопросов',
    route: 'questions',
    icon: 'HelpCircleIcon',
    resource: 'questions',
    action: 'view',
  },
]
